import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
// Google redirects back to `${origin}/auth/google?code=...&state=...` after consent.
// We forward the code to backend, which does the token exchange server-side and sets the session cookie.
export default function AuthCallback() {
  const nav = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");
    const oauthErr = params.get("error");

    if (oauthErr) {
      toast.error(`Google sign-in cancelled: ${oauthErr}`);
      nav("/login", { replace: true });
      return;
    }
    if (!code) {
      nav("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        const redirect_uri = window.location.origin + "/auth/google";
        await api.post("/auth/google/callback", { code, state, redirect_uri });
        window.history.replaceState({}, "", "/");
        await refresh();
        toast.success("Signed in with Google");
        nav("/", { replace: true });
      } catch (er) {
        const msg = er?.response?.data?.detail || "Google sign-in failed";
        toast.error(msg);
        nav("/login", { replace: true });
      }
    })();
  }, [nav, refresh]);

  return (
    <div className="min-h-[70vh] flex items-center justify-center">
      <div className="text-center">
        <Loader2 size={40} className="mx-auto text-slate-900 animate-spin mb-4" />
        <div className="font-mono-tmf uppercase tracking-widest text-sm text-slate-500">Signing you in…</div>
      </div>
    </div>
  );
}
